import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { OrderedMap } from 'immutable'
import styles from './RouteDialog.scss'
import { ConfirmationDialog } from 'common/styleguide/ConfirmationDialog'
import { RadioGroup } from 'common/styleguide/RadioGroup'
import { updateRoute } from 'lib/api/embeds/regional'
import { ColorPicker } from 'common/ColorPicker'

const colorOptions = OrderedMap({
  auto: 'Auto-generated',
  custom: 'Custom'
})
const urlTypes = OrderedMap({
  auto: 'Auto-generated',
  custom: 'Custom'
})

export class RouteDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      showColorPicker: false,
      url: props.url || '',
      urlType: props.url ? 'custom' : 'auto',
      color: props.color,
      colorType: props.customColor ? 'custom' : 'auto'
    }
  }

  urlTypeChanged = (value) => {
    this.setState({ urlType: value })
  }
  urlChanged = (e) => {
    this.setState({ url: e.target.value })
  }
  colorTypeChanged = (value) => {
    this.setState({ colorType: value })
  }
  colorChanged = (value) => {
    this.setState({ color: value })
  }

  showColorPicker = () => {
    this.setState({
      colorType: 'custom',
      showColorPicker: true
    })
  }
  hideColorPicker = () => {
    this.setState({ showColorPicker: false })
  }

  onSave = (e) => {
    if (e) e.preventDefault()

    const { url, urlType, color, colorType } = this.state

    const { routeId, updateRoute } = this.props

    const urlWithProtocol = url.indexOf('://') === -1 ? `http://${url}` : url

    updateRoute(routeId, { color: colorType === 'custom' && color, url: urlType === 'custom' && urlWithProtocol })

    this.props.onRequestClose()
  }

  render () {
    const { name, onCancel, onRequestClose } = this.props
    const { showColorPicker, url, urlType, color, colorType } = this.state

    return (
      <ConfirmationDialog
        title={<Fragment>Modify <strong>{name}</strong></Fragment>}
        confirmText='Save'
        onConfirm={this.onSave}
        onCancel={onCancel}
        onRequestClose={onRequestClose}>

        <form onSubmit={this.onSave}>
          <div>
            Route line color
            <div className={styles.Color}>
              <div ref={r => { this._colorSwatch = r }} style={{ backgroundColor: color }} className={styles.ColorSample} onClick={this.showColorPicker} />
              {showColorPicker &&
                <ColorPicker
                  color={color}
                  target={this._colorSwatch}
                  onChange={(c) => this.colorChanged(c.hex)}
                  onRequestClose={this.hideColorPicker} />}
              <RadioGroup
                name='colorType'
                options={colorOptions}
                selected={colorType}
                onChange={this.colorTypeChanged} />

            </div>
          </div>
          <div>
            URL Link
            <div>
              <input type='text' disabled={urlType === 'auto'} value={url} className={styles.urlField} onChange={this.urlChanged} />
              <RadioGroup
                name='urlType'
                options={urlTypes}
                selected={urlType}
                onChange={this.urlTypeChanged} />
            </div>
          </div>
        </form>

      </ConfirmationDialog>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = {
  updateRoute
}

export const RouteDialogContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(RouteDialog)
